import { Component, Vue } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';

import WithRender from './partners.component.html';
import UserModel from '@/models/user';
import { moduleProxy } from '@/store';
import { EventBus, Events } from '@/event-bus';
import CancelRequestComponent from '@/components/dialog/cancel-request.component.vue';
import ExternalService from '@/services/external';
import { TarafTypeEnum } from '@/enums/tarafTypeEnum';
import { PersonInfoModel } from '@/models/PersonInfoModel';
import { PersonInfoRequestModel } from '@/models/PersonInfoRequestModel';
import { CreateContractModel } from '@/models/contractDetailsModel';
import { ContractPartnerModel } from '@/models/contractPartnerModel';
import { Toaster } from '@/services/toast';
import UserService from '@/services/user';
import ApplicantComponent from '@/components/Taraf/applicant.component.vue';
import TarafComponent from '@/components/Taraf/taraf.component.vue';
import MobileComponent from '@/components/mobile.component.vue';
import NumberComponent from '@/components/number.component.vue';

@WithRender
@Component({
  components: {
    MobileComponent,
    NumberComponent,
    TarafComponent,
    ApplicantComponent,
  },
  diProvide: [
    ExternalService,
    UserService,
  ],
})
export default class Partners extends Vue {
  @Inject(ExternalService) public externalService!: ExternalService;
  @Inject(UserService) public userService!: UserService;
  currentUser = {} as UserModel;
  activePartner = {} as ContractPartnerModel;
  applicantPartner = {} as ContractPartnerModel;
  partners = [] as ContractPartnerModel[];
  contractModel = {} as CreateContractModel;
  isSetSecondPartSefa = false;
  isLawyerTabActive = false;
  formFormType = 0; // مقدم الطلب
  EditedMobileNumber = '';

  created() {
    // Subscribe to an event.
    EventBus.$on(Events.Request.ConfirmCancelRequestEvent, () => {
      moduleProxy.Contract.clearContract();
      this.$router.push({ name: 'issueContract' });
    });
  }

  mounted() {
    this.contractModel = moduleProxy.Contract.getContract;

    if (this.contractModel?.partners?.length > 0) {
      this.formFormType = 4; // hide all forms
    } else {
      this.getCurrentUser();
    }
  }

  beforeDestroy() {
    // Unsubscribe from an event.
    EventBus.$off(Events.Request.ConfirmCancelRequestEvent);
  }

  getNICUserInfo(currentUser: UserModel) {
    const nationalid = currentUser.username;
    const dateList = currentUser.birthDateHijri.split('/');
    const personInfoRequestModel = {
      nationalId: nationalid, year: dateList[0], month: dateList[1], day: dateList[2],
    } as PersonInfoRequestModel;
    this.externalService.getPersonInfo(personInfoRequestModel).then((reponse) => {
      this.mapPartnerData(reponse.model);
    }).catch(() => {
    });
  }

  getCurrentUser() {
    this.userService.getUser().then((response) => {
      this.currentUser = response;
      this.getNICUserInfo(this.currentUser);
    }).catch(() => {
    });
  }

  mapPartnerData(user: PersonInfoModel) {
    if (user?.data?.length > 0) {
      const { person } = user.data[0];
      this.activePartner = person as any;
      this.activePartner.socialId = person.id;
      this.activePartner.gender = person.sexCode;
      this.activePartner.genderDesc = person.sexDescAr;
      this.activePartner.nationalityName = person.nationalityDescAr;
      this.activePartner.birthDateHijri = this.currentUser.birthDateHijri;
      this.activePartner.partnerTarafTypeId = 1;
      this.activePartner.partnerSefaTypeId = 1;
      this.applicantPartner = JSON.parse(JSON.stringify(this.activePartner));
      delete (this.applicantPartner as any).id;
      delete this.applicantPartner.id;
    }
  }

  addActivePartner(tarafData: ContractPartnerModel) {
    tarafData.isViewMode = true;
    tarafData.isEditMobileNumber = false;
    tarafData.oldMobileNumber = tarafData.mobileNumber;
    if (this.contractPartners?.length === 0) {
      tarafData.formType = 0;
    }
    moduleProxy.Contract.setContractPartner(JSON.parse(JSON.stringify(tarafData)));
    this.activePartner = tarafData;
    this.showNextForm(tarafData);
  }

  showNextForm(addedPartner: ContractPartnerModel) {
    if (addedPartner.partnerTarafTypeId === 1 && this.contractPartners?.find((x) => x.partnerTarafTypeId === 2) === undefined) { // in case of added taraf is طرف أول
      // this.formFormType = 2//فورم طرف ثاني
      const second = {} as ContractPartnerModel;
      second.isViewMode = false;
      second.partnerTarafTypeId = 2;
      second.formType = 2;
      moduleProxy.Contract.setContractPartner(JSON.parse(JSON.stringify(second)));
    } else if (addedPartner.formType === 0 && addedPartner.partnerTarafTypeId === 3) { // in case of added taraf is محامي
      // فورم  طرف أول
      const first = {} as ContractPartnerModel;
      first.isViewMode = false;
      first.partnerTarafTypeId = 1;
      first.formType = 1;
      moduleProxy.Contract.setContractPartner(JSON.parse(JSON.stringify(first)));
    } else if (this.hasLawyer && addedPartner?.partnerTarafTypeId === 2 && this.contractPartners?.length > 1
      && this.contractPartners?.find((x) => x.partnerTarafTypeId === 3) === undefined) {
      // this.formFormType = 3;//فورم  المحامي
      const lawyer = { isViewMode: false, partnerTarafTypeId: 3, formType: 3 } as ContractPartnerModel;
      moduleProxy.Contract.setContractPartner(JSON.parse(JSON.stringify(lawyer)));
    } else if (addedPartner?.partnerTarafTypeId === 2 && this.contractPartners?.length === 1) { // added second as first index
      // this.formFormType = 1;//فورم  الطرف الاول
      const first = { isViewMode: false, partnerTarafTypeId: 1, formType: 1 } as ContractPartnerModel;
      moduleProxy.Contract.setContractPartner(JSON.parse(JSON.stringify(first)));
    } else if (this.hasLawyer && addedPartner?.partnerTarafTypeId === 1
      && this.contractPartners?.find((x) => x.partnerTarafTypeId === 2) !== undefined
      && this.contractPartners?.find((x) => x.partnerTarafTypeId === 3) === undefined) { // added first after second (so lawyer will added)
      // this.formFormType = 3;//فورم  المحامي
      const lawyer = { isViewMode: false, partnerTarafTypeId: 3, formType: 3 } as ContractPartnerModel;
      moduleProxy.Contract.setContractPartner(JSON.parse(JSON.stringify(lawyer)));
    }
    if (moduleProxy.Contract?.getContractPartners?.length === 3) {
      this.formFormType = 4;// hide form
    }
  }

  editPartner(index: number, partner: ContractPartnerModel) {
    const formsToRemove = moduleProxy.Contract.getContractPartners.filter((x) => x.isViewMode === false);
    moduleProxy.Contract.removeContractPartners(formsToRemove);
    partner.isViewMode = false;
  }

  removePartner(index: number, partner: ContractPartnerModel) {
    const newPartner = { isViewMode: false, partnerTarafTypeId: partner.partnerTarafTypeId, formType: partner.formType } as ContractPartnerModel;
    moduleProxy.Contract.replacePartner(newPartner);
    partner.isViewMode = false;
  }

  get contractPartners() {
    return moduleProxy.Contract.getContractPartners;
  }

  setMobileEditMode(partner: ContractPartnerModel) {
    partner.isEditMobileNumber = true;
    moduleProxy.Contract.setIsEditMobileNumber(partner);
  }

  editMobile(partner: ContractPartnerModel) {
    if (this.$refs.formRef) {
      (this.$refs.formRef as any).validate().then((success: boolean) => {
        if (success) {
          partner.oldMobileNumber = partner.mobileNumber;
          partner.isEditMobileNumber = false;
        }
      });
    }
  }

  cancelEditMobile(partner: ContractPartnerModel) {
    partner.mobileNumber = partner.oldMobileNumber;
    partner.isEditMobileNumber = false;
  }

  async nextStep(): Promise<void> {
    const isValid = await (this.$refs.formRef as any).validate();

    if (!isValid) return;

    const firstPartner = moduleProxy.Contract.getContract.partners.find((x) => x.partnerTarafTypeId === TarafTypeEnum.FirstPartner);
    const secondPartner = moduleProxy.Contract.getContract.partners.find((x) => x.partnerTarafTypeId === TarafTypeEnum.SecondPartner);
    const lawyerPartner = moduleProxy.Contract.getContract.partners.find((x) => x.partnerTarafTypeId === TarafTypeEnum.Lawyer);

    if (!firstPartner?.socialId) {
      Toaster.error({ message: 'الرجاء إضافة بيانات الطرف الأول' });
    } else if (!secondPartner?.socialId) {
      Toaster.error({ message: 'الرجاء إضافة بيانات الطرف الثاني' });
    } else if (this.hasLawyer && !lawyerPartner?.socialId) {
      Toaster.error({ message: 'الرجاء إضافة بيانات المحامي' });
    } else {
      this.$router.push({ name: 'contractDuration' });
    }
  }

  previousStep() {
    this.$router.push({ name: 'issueContract' });
  }

  /**
   * Initiate cancel request process.
   */
  onCancel(): void {
    // Publish an event.
    EventBus.$emit(Events.Dialog.OpenDialogEvent, CancelRequestComponent);
  }

  get hasLawyer() {
    return moduleProxy.Contract.getHasLawyer;
  }
}
